import { Box, Grid2, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import useNavigationGuard from "../../../../hooks/useNavigationGuard";
import Loader from "../../../../components/Loader";
import { CreateHandleUnsaveNavigation } from "../../../../utilities/handleUnsaveNavigation";
import { HandleUnsaveNavigationWithFun } from "../../../../utilities/handleUnsaveNavigationWithFun";
import SearchableSelect from "../../../../components/SearchableSelect";
import DataCorrectionGrid from "../../../../components/DataCorrectionGrid/DataCorrectionGrid";
import SubmitDataCorrection from "./SubmitDataCorrection/SubmitDataCorrection";
import DataCorrectionConfirmation from "./DataCorrectionConfirmation/DataCorrectionConfirmation";
import DataCorrectionModal from "../../../../components/DataCorrectionModal/DataCorrectionModal";
import {
  createCorrectionService,
  getChangeQuestionnaireResponseService,
  getDataCorrectionDataOnLoadService,
  getDiaryEntryService,
  getDiaryPagesService,
  getPatientAttribuesService,
} from "../../../../services/subjectService";
import UncontrolledSearchSelect from "../../../../components/UncontrolledSearchSelect";
import {
  buildFormFields,
  buildPatientAttributeFields,
  getFieldType,
} from "./Helper/helper";
import {
  generateShortId,
  generateUUID,
  notifyError,
  notifySuccess,
} from "../../../../utilities/helper";
import { findNode } from "../../DynamicForm/helper";

const DataCorrectionTwo = () => {
  const id = useLocation()?.state?.id;

  const roleId = localStorage.getItem("roleId");
  const cultureCode = localStorage.getItem("currentUserCultureCode");

  const [load, setLoad] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const [patientId, setPatientId] = useState("");
  const [siteName, setSiteName] = useState("");
  const [correctionData, setCorrectionData] = useState([]);
  const [ddlResponseData, setDdlReponseData] = useState([]);
  const [showSubmitPage, setShowSubmitPage] = useState(false);
  const [submitData, setSubmitData] = useState(null);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [password, setPassword] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationData, setConfirmationData] = useState(null);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState(null);
  const [correctionPayload, setCorrectionPayload] = useState({
    createPayload: null,
    correctionId: "",
    correctionStatusId: "",
  });
  const [payload, setPayload] = useState(null);
  const [allJsons, setAllJsons] = useState([]);
  const [questionJson, setQuestionJson] = useState(null);
  const [answers, setAnswers] = useState(null);
  const [correctionTableData, setCorrectionTableData] = useState([]);
  const [showMergeSubjectWarning, setMergeSubjectWarning] = useState(false);
  const [showRemoveSubject, setShowRemoveSubject] = useState(false);
  const [patientAttribute, setPatientAttribute] = useState(null);
  const [isPatientAttributeDisabled, setIsPatientAttributeDisabled] =
    useState(false);
  const [siteId, setSiteId] = useState(null);
  const [visitsData, setVisitsData] = useState([]);
  const [visitNumber, setVisitNumber] = useState("");

  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");
  const email = localStorage.getItem("email");
  const singlePatientAlias = localStorage.getItem("singlePatientAlias");
  const globalDateFormat = localStorage?.getItem("globalDateFormat");

  const handleUnsaveNavigation = CreateHandleUnsaveNavigation();
  const handleUnSaveWithFun = HandleUnsaveNavigationWithFun();

  const createDataCreationSchema = yup.object().shape({
    typeOfCorrection: yup.string().required("Type of Correction is required"),
    reason: yup.string().required("Reason for Correction is required"),
  });

  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isDirty },
  } = useForm({
    resolver: yupResolver(createDataCreationSchema),
    defaultValues: {
      reason: "",
      typeOfCorrection: "",
    },
  });

  const { correctionId, createPayload, correctionStatusId } = correctionPayload;

  useNavigationGuard(isDirty);
  const { typeOfCorrection } = watch();

  useEffect(() => {
    if (id && roleId && cultureCode && access_token) {
      getOnLoadData(id);
    }
  }, [id]);

  useEffect(() => {
    if (
      typeOfCorrection !== "" &&
      correctionData &&
      correctionData?.length > 0
    ) {
      const displayName = correctionData?.find(
        (ele) => ele?.id === typeOfCorrection,
      )?.displayName;
      if (
        displayName === "Change Questionnaire responses" ||
        displayName === "Change Questionnaire information" ||
        displayName === "Change Subject Visit"
      ) {
        getResponseForChangeQuestionnaireResponse();
        getDataForChangeDropdown(displayName);
        setMergeSubjectWarning(false);
        setShowRemoveSubject(false);
      } else if (displayName === "Change Subject Information") {
        getResponseForChangeQuestionnaireResponse();
      } else if (displayName === "Merge Subjects") {
        setSelectedQuestionnaire(null);
        setMergeSubjectWarning(true);
        setShowRemoveSubject(false);
      } else if (displayName === "Remove A Subject") {
        getResponseForChangeQuestionnaireResponse();
        setSelectedQuestionnaire(null);
        setMergeSubjectWarning(false);
        setShowRemoveSubject(true);
      }
    }
  }, [typeOfCorrection, correctionData]);

  useEffect(() => {
    if (typeOfCorrection) {
      const displayName = correctionData?.find(
        (ele) => ele?.id === typeOfCorrection,
      )?.displayName;

      if (
        selectedQuestionnaire &&
        correctionId &&
        displayName !== "Change Subject Information"
      ) {
        getDiaryEntry(correctionId, selectedQuestionnaire);
      } else if (correctionId && displayName === "Change Subject Information") {
        setSelectedQuestionnaire(null);
        getPatientAttributes(correctionId);
      }
    }
  }, [selectedQuestionnaire, correctionId, typeOfCorrection]);

  useEffect(() => {
    if (typeOfCorrection) {
      const displayName = correctionData?.find(
        (ele) => ele?.id === typeOfCorrection,
      )?.displayName;

      if (
        displayName === "Change Subject Information" &&
        patientAttribute == null
      ) {
        setIsPatientAttributeDisabled(true);
      } else if (
        displayName === "Change Subject Information" &&
        patientAttribute !== null &&
        patientAttribute &&
        patientAttribute?.length > 0
      ) {
        setIsPatientAttributeDisabled(false);
      } else if (
        displayName !== "Change Subject Information" &&
        patientAttribute == null
      ) {
        setIsPatientAttributeDisabled(false);
      }
    }
  }, [typeOfCorrection, patientAttribute]);

  useEffect(() => {
    if (isAuthorized) {
      setShowConfirmation(true);
    }
  }, [isAuthorized]);

  useEffect(() => {
    if (typeOfCorrection) {
      const displayName = correctionData?.find(
        (ele) => ele?.id === typeOfCorrection,
      )?.displayName;
      if (displayName !== "Change Subject Information") {
        if (answers && answers?.length > 0 && questionJson) {
          setCorrectionTableData(
            buildFormFields(
              answers,
              questionJson,
              allJsons,
              displayName,
              visitsData,
              visitNumber,
            ),
          );
        }
      } else {
        setCorrectionTableData(
          buildPatientAttributeFields(patientAttribute, questionJson),
        );
      }
    }
  }, [answers, questionJson, typeOfCorrection]);

  const getOnLoadData = async (id) => {
    try {
      setLoad(true);
      const res = await getDataCorrectionDataOnLoadService(
        access_token,
        id,
        roleId,
        cultureCode,
      );
      if (
        res?.status == 200 &&
        res?.data?.message === "Online data extracted successfylly!"
      ) {
        const viewData = res?.data?.result?.correction;
        const formData = res?.data?.result?.viewBagData;
        setSubjectName(viewData?.patientNumber);
        setSiteId(viewData?.siteId);
        setPayload(viewData);
        setSiteName(viewData?.siteName);
        setCorrectionData(formData?.correctionTypes);
        setPatientId(viewData?.patientId);
      }
    } catch (err) {
      console.log("Error: ", err);
      if (err?.status == 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  const getResponseForChangeQuestionnaireResponse = async () => {
    try {
      setLoad(true);
      const res = await getChangeQuestionnaireResponseService(
        access_token,
        roleId,
        cultureCode,
        payload,
      );
      if (
        res?.status == 200 &&
        res?.data?.message === "executed successfully!"
      ) {
        setCorrectionPayload({
          correctionId: res?.data?.result?.correction?.id,
          createPayload: res?.data?.result?.correction,
          correctionStatusId: res?.data?.result?.correctionStatusId,
        });
      }
    } catch (err) {
      console.log("Error", err.message);
      if (err.status == 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  const getDataForChangeDropdown = async (displayName) => {
    try {
      setLoad(true);
      if (
        displayName === "Change Questionnaire responses" ||
        displayName === "Change Questionnaire information" ||
        displayName === "Change Subject Visit"
      ) {
        const res = await getDiaryPagesService(
          access_token,
          id,
          globalDateFormat,
          cultureCode,
        );
        if (
          res?.status == 200 &&
          res?.data?.message === "executed successfully!"
        ) {
          const data = res?.data?.result?.diaryEntries;
          setDdlReponseData(data);
          setVisitsData(res?.data?.result?.visits);
        }
      }
    } catch (err) {
      console.log("Error", err?.message);
      if (err?.status == 401) {
        navigate("/unAuthorized");
      }
    } finally {
      setLoad(false);
    }
  };

  const getDiaryEntry = async (correctionId, diaryEntryId) => {
    try {
      setLoad(true);
      const res = await getDiaryEntryService(
        access_token,
        correctionId,
        diaryEntryId,
        cultureCode,
        globalDateFormat,
      );
      if (
        res.status == 200 &&
        res?.data?.message === "executed successfully!"
      ) {
        const data = res?.data?.result?.diaryEntry;
        setAnswers(data?.answers);
        data?.questionAnswers?.forEach((item) => {
          setAllJsons((prev) => [...prev, JSON.parse(item?.question?.json)]);
        });
        setQuestionJson(
          JSON.parse(
            data?.questionAnswers?.[data?.questionAnswers?.length - 1]?.question
              ?.json,
          ),
        );
      }
    } catch (err) {
      console.log("Error", err?.message);
    } finally {
      setLoad(false);
    }
  };

  const getPatientAttributes = async (correctionId) => {
    try {
      setLoad(true);
      const res = await getPatientAttribuesService(
        access_token,
        id,
        correctionId,
        cultureCode,
        null,
      );
      if (
        res?.status === 200 &&
        res?.data?.result &&
        res?.data?.result?.length > 0
      ) {
        const data = res?.data?.result;
        setPatientAttribute(data?.map((item) => item.patientAttribute));
        setQuestionJson(JSON.parse(data?.[0]?.question?.json));
      } else {
        setPatientAttribute(null);
      }
    } catch (err) {
      console.log("Error:", err?.message);
    } finally {
      setLoad(false);
    }
  };

  const handleNext = (data) => {
    setSubmitData({ ...data });
    setShowSubmitPage(true);
  };

  const onSubmit = async (data) => {
    setSubmitData({ ...data });
    setShowSubmitPage(true);
    let payload = {};
    let temp = [];
    const displayName = correctionData?.find(
      (ele) => ele?.id === typeOfCorrection,
    )?.displayName;

    if (showRemoveSubject) {
      let obj = {
        oldDisplayValue: "Enrolled",
        newDisplayValue: "Removed",
        rowName: "The Selected Subject will be removed",
        description: correctionData?.find((ele) => ele?.id == typeOfCorrection)
          ?.displayDescription,
      };
      temp.push(obj);
    } else if (displayName === "Change Subject Information") {
      patientAttribute?.forEach((item) => {
        if (item?.displayValue !== "") {
          let questionId = item?.patientAttributeConfigurationDetail?.id;
          let requestedField = "";
          let deleteField = false;
          Object.keys(data)?.forEach((ele) => {
            if (
              ele?.split("_")[0] == questionId &&
              ele?.split("_")[1] === "requested"
            ) {
              requestedField = data[ele];
            }
            if (
              ele?.split("_")[0] == questionId &&
              ele?.split("_")[1] === "remove"
            ) {
              deleteField = data[ele];
            }
          });

          let rowName = correctionTableData?.find(
            (ele) => ele?.removeFieldName.split("_")[0] === questionId,
          )?.fieldName;
          let obj = {
            id: item?.id,
            questionId: item?.questionId,
            oldDisplayValue: item?.displayValue,
            rowName: rowName,
            newDisplayValue: requestedField || "",
            removeItem: deleteField,
            description: correctionData?.find(
              (ele) => ele?.id == typeOfCorrection,
            )?.displayDescription,
          };
          temp.push(obj);
        }
      });
    } else {
      if (displayName === "Change Subject Visit") {
        answers?.forEach((item) => {
          if (item?.displayAnswer !== "") {
            let questionId = item?.questionId;
            let requestedField = "";
            let deleteField = false;

            Object.keys(data)?.forEach((ele) => {
              const [id, type] = ele.split("_");

              if (id == questionId && type === "requested") {
                requestedField = data[ele];
              }

              if (id == questionId && type === "remove") {
                deleteField = data[ele];
              }
            });

            let rowName = correctionTableData?.find(
              (ele) => ele?.removeFieldName.split("_")[0] === questionId,
            )?.fieldName;

            if (requestedField || deleteField) {
              let obj = {
                id: item?.id,
                questionId: item?.questionId,
                rowName: rowName,
                oldDisplayValue: item?.value,
                newDisplayValue: requestedField || "",
                removeItem: deleteField,
                description: correctionData?.find(
                  (ele) => ele?.id == typeOfCorrection,
                )?.displayDescription,
              };

              temp.push(obj);
            }
          }
        });
      } else if (displayName === "Change Questionnaire information") {
        // 🔹 1. Handle visitdatepicker (date field)
        const visitDateItem = answers?.find((item) => {
          if (!item?.displayAnswer) return false;

          const questionNode = findNode(questionJson, item?.questionId);
          const fieldType = getFieldType(questionNode, item);

          return fieldType === "visitdatepicker";
        });

        if (visitDateItem) {
          const questionId = visitDateItem?.questionId;

          const requestedField = data?.[`${questionId}_requested`] || "";

          const deleteField = data?.[`${questionId}_remove`] || false;

          let rowName = correctionTableData?.find(
            (ele) => ele?.removeFieldName.split("_")[0] === questionId,
          )?.fieldName;

          if (requestedField || deleteField) {
            temp.push({
              id: generateUUID(),
              questionId: visitDateItem?.questionId,
              oldDisplayValue: visitDateItem?.value,
              rowName: rowName,
              newDisplayValue: requestedField,
              removeItem: deleteField,
              description: correctionData?.find(
                (ele) => ele?.id == typeOfCorrection,
              )?.displayDescription,
            });
          }
        }

        const visitId = data?.["visit_name_requested"];

        if (visitId) {
          temp.push({
            id: generateUUID(),
            questionId: generateUUID(),
            oldDisplayValue: visitNumber, // optional (or previous visit if you have)
            newDisplayValue: visitId, // ✅ send ID
            removeItem: false,
            rowName: "Visit Name",
            description: correctionData?.find(
              (ele) => ele?.id == typeOfCorrection,
            )?.displayDescription,
          });
        }
      } else {
        answers?.forEach((item) => {
          if (item?.displayAnswer !== "") {
            let questionId = item?.questionId;
            let requestedField = "";
            let deleteField = false;
            Object.keys(data)?.forEach((ele) => {
              if (
                ele?.split("_")[0] == questionId &&
                ele?.split("_")[1] === "requested"
              ) {
                requestedField = data[ele];
              }
              if (
                ele?.split("_")[0] == questionId &&
                ele?.split("_")[1] === "remove"
              ) {
                deleteField = data[ele];
              }
            });
            let rowName = correctionTableData?.find(
              (ele) => ele?.removeFieldName.split("_")[0] === questionId,
            )?.fieldName;
            let obj = {
              id: item?.id,
              questionId: item?.questionId,
              rowName: rowName,
              oldDisplayValue: item?.value,
              newDisplayValue: requestedField || "",
              removeItem: deleteField,
              description: correctionData?.find(
                (ele) => ele?.id == typeOfCorrection,
              )?.displayDescription,
            };
            temp.push(obj);
          }
        });
      }
    }

    payload = {
      ...createPayload,
      correctionType: {
        id: typeOfCorrection,
        startedByUserId: roleId,
        correctionStatusId: correctionStatusId,
        displayTextAsColumnValue:
          createPayload?.correctionType?.displayTextAsColumnValue,
        displayName: correctionData?.find((ele) => ele?.id == typeOfCorrection)
          ?.displayName,
        displayDescription: correctionData?.find(
          (ele) => ele?.id == typeOfCorrection,
        )?.displayDescription,
        translationKey: generateShortId(),
      },
      displayName: correctionData?.find((ele) => ele?.id == typeOfCorrection)
        ?.displayName,
      displayDescription: correctionData?.find(
        (ele) => ele?.id == typeOfCorrection,
      )?.displayDescription,
      translationKey: generateShortId(),
      correctionTypeId: typeOfCorrection,
      reasonForCorrection: data["reason"],
      patientId: patientId,
      correctionApprovalData: temp,
      // diaryEntryId: selectedQuestionnaire,
      diaryEntry: ddlResponseData?.find(
        (ele) => ele?.id === selectedQuestionnaire,
      ),
    };

    if (selectedQuestionnaire) {
      payload.diaryEntryId = selectedQuestionnaire;
    }
    try {
      setLoad(true);
      const res = await createCorrectionService(
        access_token,
        roleId,
        cultureCode,
        singlePatientAlias,
        siteId,
        payload,
      );
      if (
        res?.status === 200 &&
        res?.data?.message === "Executed successfully!"
      ) {
        notifySuccess("Data Correction Added succesfully !");
        setShowConfirmation(true);
        setConfirmationData(res?.data?.result);
      }
    } catch (err) {
      if (err?.status === 401) {
        navigate("/unAuthorized");
      }
      notifyError(err?.message || "Something went wrong !");
      console.log("Error", err?.message);
    } finally {
      setLoad(false);
    }

    // if (showSubmitPage) {
    //   setShowPasswordModal(true);
    // }
  };

  return (
    <>
      {showConfirmation ? (
        <DataCorrectionConfirmation
          correctionData={correctionTableData}
          id={id}
          data={submitData}
          setShowConfirm={setShowConfirmation}
          subjectName={subjectName}
          isRemovedSubject={showRemoveSubject}
        />
      ) : (
        <>
          {showSubmitPage && submitData ? (
            <SubmitDataCorrection
              description={
                correctionData?.find((ele) => ele?.id === typeOfCorrection)
                  ?.displayName
              }
              siteName={siteName}
              subjectName={subjectName}
              title={"Submit Data Correction"}
              id={id}
              data={submitData}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
              setShowSubmitPage={setShowSubmitPage}
              showPasswordModal={showPasswordModal}
              pageDescription={
                correctionData?.find((ele) => ele?.id === typeOfCorrection)
                  ?.displayDescription
              }
              correctionData={correctionTableData}
              load={load}
              isRemovedSubject={showRemoveSubject}
            />
          ) : (
            <>
              {load ? (
                <Loader />
              ) : (
                <div className="content-body">
                  <p className="bread-crumbs-link-container">
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) =>
                        handleUnsaveNavigation(e, isDirty, "", navigate)
                      }
                    >
                      Home
                    </button>{" "}
                    |{" "}
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) => {
                        navigate("/subject");
                      }}
                    >
                      Subject Management
                    </button>
                    {" | "}
                    <button
                      className="bread-crumbs-btn"
                      onClick={(e) =>
                        handleUnsaveNavigation(
                          e,
                          isDirty,
                          "update-subject",
                          navigate,
                        )
                      }
                    >
                      {subjectName || "Subject Details"}
                    </button>{" "}
                    |{" "}
                    <button
                      className="bread-crumbs-btn"
                      to="/subject-data-correction"
                    >
                      Create Data Correction
                    </button>
                    -{" "}
                    <b style={{ color: "gray" }}>
                      {localStorage?.getItem("studyName")}
                    </b>
                  </p>
                  <Grid2
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ width: "100%", margin: "0 auto" }}
                  >
                    <Grid2 item md={12}>
                      <p className="page-heading">Create Data Correction</p>
                    </Grid2>
                  </Grid2>

                  <Box
                    component="form"
                    autoComplete="off"
                    sx={{ height: "auto", width: "100%" }}
                    // onSubmit={handleSubmit(onSubmit)}
                    onSubmit={handleSubmit(handleNext)}
                  >
                    <Grid2
                      container
                      alignItems="center"
                      justifyContent={"center"}
                      sx={{ width: "100%", margin: "0 auto" }}
                      gap={5}
                    >
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "40px",
                          }}
                        >
                          <div
                            style={{
                              width: "100px",
                            }}
                          >
                            <span>Site Name:</span>
                          </div>
                          <div>{siteName}</div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "40px",
                            marginTop: "20px",
                          }}
                        >
                          <div
                            style={{
                              width: "100px",
                            }}
                          >
                            <span>Subject :</span>
                          </div>
                          <div>{subjectName}</div>
                        </div>

                        <div
                          style={{
                            width: "500px",
                            marginTop: "20px",
                          }}
                        >
                          <div
                            style={{
                              marginBottom: "10px",
                            }}
                          >
                            <span>Type of Correction:</span>
                          </div>
                          <SearchableSelect
                            control={control}
                            data={
                              correctionData
                              // ?.filter(
                              // (ele) => ele?.displayName !== "Change",
                              // &&
                              //   ele?.displayName !==
                              //     "Change Subject Information",
                              // )
                            }
                            name={"typeOfCorrection"}
                            optionKey="id"
                            optionLabel="displayName"
                          />
                        </div>
                        {errors.typeOfCorrection && (
                          <div className="error-container">
                            {errors.typeOfCorrection.message}
                          </div>
                        )}
                      </div>
                      <div>
                        <div>
                          <div
                            style={{
                              marginBottom: "10px",
                            }}
                          >
                            <span>Reason for Correction:</span>
                          </div>
                          <TextField
                            rows={4}
                            type={"text"}
                            {...register("reason")}
                            multiline
                            sx={{
                              width: "500px",
                            }}
                          />
                          {errors.reason && (
                            <div className="error-container">
                              {errors.reason.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </Grid2>

                    {typeOfCorrection && (
                      <Grid2
                        container
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{
                          width: "55vw",
                          minWidth: "61vw",
                          margin: "20px auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "start",
                            width: "100%",
                          }}
                        >
                          <h2
                            style={{
                              color: "#4f4f4f",
                            }}
                          >
                            {
                              correctionData?.find(
                                (item) => item?.id === typeOfCorrection,
                              )?.displayName
                            }
                          </h2>
                        </div>
                        {showMergeSubjectWarning ? (
                          <p>
                            There are no duplicate instances of subject number{" "}
                            {subjectName}
                          </p>
                        ) : (
                          <>
                            {showRemoveSubject ? (
                              <p>The Selected Subject will be removed.</p>
                            ) : (
                              <>
                                {correctionData?.find(
                                  (ele) => ele?.id === typeOfCorrection,
                                )?.displayName !==
                                "Change Subject Information" ? (
                                  <>
                                    <div>
                                      <h3 style={{ color: "#4f4f4f" }}>
                                        Select a Questionnaire
                                      </h3>
                                    </div>

                                    <UncontrolledSearchSelect
                                      data={ddlResponseData}
                                      name={"selectedQuestionnaire"}
                                      optionKey="id"
                                      value={selectedQuestionnaire}
                                      onChange={(selectedValue) => {
                                        setSelectedQuestionnaire(selectedValue);
                                        const data = ddlResponseData?.find(
                                          (ele) => ele?.id === selectedValue,
                                        );
                                        setVisitNumber(data?.visitId);
                                      }}
                                      optionLabel={`visitName`}
                                      extraLabel="diaryEntryDateDisplay"
                                    />

                                    {selectedQuestionnaire && (
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          width: "100%",
                                        }}
                                      >
                                        <DataCorrectionGrid
                                          control={control}
                                          register={register}
                                          disabled={false}
                                          errors={errors}
                                          tableData={correctionTableData}
                                        />
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <DataCorrectionGrid
                                      control={control}
                                      register={register}
                                      disabled={false}
                                      errors={errors}
                                      tableData={correctionTableData}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </Grid2>
                    )}

                    <Grid2
                      alignItems={"end"}
                      justifyContent="end"
                      container
                      gap={3}
                      sx={{ marginTop: "2%" }}
                    >
                      <Grid2 item md={6}>
                        <button
                          type="button"
                          className="create-btn-outlined"
                          onClick={(e) => {
                            e.preventDefault();
                            handleUnSaveWithFun(
                              e,
                              isDirty,
                              () =>
                                navigate("/update-subject", {
                                  state: {
                                    id: id,
                                  },
                                }),
                              () => {},
                            );
                          }}
                        >
                          Cancel
                        </button>
                      </Grid2>
                      <Grid2 item md={6}>
                        <button
                          type="submit"
                          className={
                            showMergeSubjectWarning ||
                            isPatientAttributeDisabled
                              ? "disabled-btn"
                              : `create-btn`
                          }
                          disabled={
                            showMergeSubjectWarning ||
                            isPatientAttributeDisabled
                          }
                        >
                          Next
                        </button>
                      </Grid2>
                    </Grid2>
                  </Box>
                </div>
              )}
            </>
          )}
          {showPasswordModal && (
            <DataCorrectionModal
              password={password}
              setPassword={setPassword}
              setIsAuthorized={setIsAuthorized}
              setShowModal={setShowPasswordModal}
              showModal={showPasswordModal}
              userName={email}
            />
          )}
        </>
      )}
    </>
  );
};

export default DataCorrectionTwo;
